import { COUPON_OFFERS, REWARD_OFFERING } from "../constants";
import { getRedeemUrlWithContext } from "../utils";
import { RetrieveCoupon } from "../common/utils/RetrieveCoupon";
import AdobeCompetitionOnboarding from "../common/components/AdobeCompetitionOnboarding";

function BridgeToBrisbaneMain() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.bridgetobrisbane);
  const redeemUrl = getRedeemUrlWithContext("bridge-to-brisbane");

  return (
    <>
      {!loading && (
        <AdobeCompetitionOnboarding
          partnerCfg={GLOBAL_CFG["bridge-to-brisbane"]}
          redeemUrl={redeemUrl}
          coupon={coupon}
          rewardId={REWARD_OFFERING.bridgetobrisbane}
        />
      )}
    </>
  );
}

export default BridgeToBrisbaneMain;